import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import SendQrModal from '../../pages/Modals/SendQrModal';
import { qrCodeByEmail } from '../../reduxToolkit/CompanyEmployees/CompanyEmployeesApi';
import ButtonAction from './ButtonAction';
import {QrIcon} from './IconButtons';

const SendQrBtn = ({ userId }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [showModal, setShowModal] = useState(false);

    const sendQr = () => {
        dispatch(qrCodeByEmail(userId));
    };

    return (
        <>
            <ButtonAction
                id='btn_sqb_send_qr'
                name='send_qr_code'
                className='btn-icon-accent-450'
                Icon={QrIcon}
                disabled={false}
                splitName={false}
                onClick={()=>{
                    setShowModal(true);
                }}
            />
            <SendQrModal
                show={showModal}
                onHide={() => setShowModal(false)}
                onClickFn={() => sendQr()}
                title_modal={t('send_qr_code')}
                description={'to_send_the_qr_code_of_the_user_you_must_confirm_the_action'}
                element_modal={t('employees')}
            />
        </>
    );
};

export default SendQrBtn;
